import { gql } from '@apollo/client'

export const USER_UUID_QUERY = gql`
  query AP_MemberUuid($id: ID!) {
    patient(id: $id) {
      id
      uuid
      first_name
      last_name
    }
  }
`
